// @ts-strict

import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { environment } from '@env/environment';
import { BaseApiResponse } from '@app/core/models/core-models';

export class ServerTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  private errorState = false;
  private waiter = new Subject<Array<Record<string, any>> | undefined>();
  private requestedLang: string | undefined;

  public getTranslation(lang: string): Observable<Array<Record<string, any>> | undefined | {}> {
    if (this.errorState) {
      return of({});
    }
    if (this.requestedLang !== null && this.requestedLang === lang) {
      return this.waiter.asObservable();
    }
    this.requestedLang = lang;
    this.http
      .get<BaseApiResponse<{ translations?: Record<string, Array<Record<string, any>> | undefined> }>>(environment.apiUrl + '/utils/languages/translations')
      .subscribe(result => {
        this.waiter.next(result.data?.translations?.[lang]);
        sessionStorage.setItem('isTranslationRead', 'yes');
      });
    return this.waiter.asObservable();
  }
}
